import { render } from "./PackageTable.vue?vue&type=template&id=40bb3a97&scoped=true"
import script from "./PackageTable.vue?vue&type=script&lang=js"
export * from "./PackageTable.vue?vue&type=script&lang=js"

import "./PackageTable.vue?vue&type=style&index=0&id=40bb3a97&scoped=true&lang=css"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40bb3a97"]])

export default __exports__